import IconCross from "../../../Common/Icons/IconCross";
import IconTick from "../../../Common/Icons/IconTick";
import { FormState } from "../../state";

interface PollInterface {
  correct: boolean;
  optionName: string;
  text?: string | null;
  type: FormState["type"];
  showWrong?: boolean;
  answeringMode?: boolean;
  onClick?: () => void;
}

export default function MCQPollOption(props: PollInterface) {
  return (
    <div
      onClick={props.onClick}
      className={`${
        props.correct
          ? "border-brij-Blue bg-brij-Blue/10"
          : props.showWrong
          ? "border-brij-Red"
          : "border-brij-LightGrey"
      } bg-brij-White container flex items-center justify-start gap-2.5 rounded-3xl border-[3px] border-solid px-4 h-full w-full relative ${
        props.onClick ? "cursor-pointer" : ""
      }`}
    >
      {/* <div className=" text-xl font-light text-brij-Black h-full w-full bg-red-500 text-ellipsis whitespace-no-wrap overflow-y-hidden overflow-x-auto"> */}
      <span className="text-red-400 absolute left-1 top-1 text-md">
        {props.optionName}
      </span>
      <p className="font-ePanel text-xl font-light text-brij-Black overflow-x-scroll w-full whitespace-nowrap mcq-poll-options ml-0.5">
        {props.text ?? "Enter Answer Text"}
      </p>
      {/* </div> */}
      {props.correct && !props.answeringMode ? (
        <div className="grid place-items-center">
          <div className="w-6 h-6 bg-brij-Blue stroke-brij-White stroke-[3.5px] rounded-full p-1">
            <IconTick />
          </div>
        </div>
      ) : (
        props.showWrong && (
          <div className="grid place-items-center">
            <div className="w-6 h-6 bg-brij-Red stroke-brij-White stroke-[3.5px] rounded-full p-1">
              <IconCross />
            </div>
          </div>
        )
      )}
    </div>
  );
}
